{
  "Approve": "Genehmigen",
  "DeleteReminder": "Erinnerung löschen",
  "DismissAlert": "Verwerfen",
  "DismissReminder": "Erinnerung verwerfen",
  "Earlier": "FRÜHER",
  "EditReminder": "Erinnerung bearbeiten",
  "High": "Hoch",
  "MarkAllAsRead": "Alle als gelesen markieren",
  "Reject": "Ablehnen",
  "RemindMe15Min": "Erinnere mich in 15 Minuten",
  "RemindMe5Min": "Erinnere mich in 5 Minuten",
  "RemindMe60Min": "Erinnere mich in einer Stunde",
  "RemindMeTomorrow": "Erinnere mich morgen",
  "Snooze": "Erinnern",
  "markAsRead": "Als gelesen markieren",
  "markAsUnread": "Als ungelesen markieren",
  "noNotifications": "Sie erhalten wichtige Informationen zu Ihren Produkten, zu Ihrer Zusammenarbeit mit anderen Benutzern und sonstige wichtige Aktualisierungen.",
  "noNotificationsTitle": "Ihre Benachrichtigungen werden hier angezeigt"
}
